import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {getLocalStorage} from '@/Utils/CommonUtils';
import ChessRestClient from '@/Api/ChessRestClient';

export function usePrizeTournamentsApi(
    user_id: string | number,
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
): UseQueryResult<any, Error> {
  return useQuery({
    queryKey: ['prizeTournaments',user_id],
    enabled: !!user_id,
    queryFn: async () => {
      const token = await getLocalStorage('access_token');
      const options = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
        params: { user_id },
      };
      const res = await ChessRestClient.get(
         '/v1/get-prize-tournaments',
        options,
      );
      return res.data;
    },
    onSuccess: handleOnSuccess,
    onError: handleOnError,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
}
